import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Cell
} from "recharts";
import { Card, Badge } from "react-bootstrap";

function CityBarChart() {
  const [citiesData, setCitiesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("./dati_dashboard.json");
        const data = await response.json();

        const transformedData = Object.keys(data.AR.paesi).map((key) => {
          const countryData = data.AR.paesi[key];
          const totalValore = countryData.reduce((acc, curr) => acc + parseFloat(curr.valore), 0);
          const totalNumero = countryData.reduce((acc, curr) => acc + parseInt(curr.numero), 0);

          return {
            nazione: key, // Ripristinato il nome originale CON gli spazi
            valore: totalValore,
            numero: totalNumero,
          };
        });

        transformedData.sort((a, b) => b.valore - a.valore);
        setCitiesData(transformedData.slice(0, 5));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  return (
    <Card className="card bg-dark ombra card-week card-home hover-effect border-0" style={{ borderRadius: '15px', padding: '1rem' }}>
      <div className="d-flex justify-content-between align-items-center mb-4 px-3">
        <div>
          <h6 className="text-title2 fw-bold mb-0" style={{ letterSpacing: '1px' }}>ORDINI PER NAZIONE</h6>
          <small className="text-light" style={{ fontSize: '0.65rem' }}>Totale vendite internazionali</small>
        </div>
        <span className="rounded-pill text-light fw-bold" style={{fontSize: '0.6rem', padding: '5px 10px', backgroundColor: 'rgba(241,111,36,1)' }}> GLOBAL</span>
      </div>

      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={citiesData}
            layout="vertical"
            // Aumentato il margine sinistro a 100 per ospitare i nomi interi
            margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
            barCategoryGap="20%"
          >
            <XAxis type="number" hide />
            
            {/* YAxis riattivato e configurato per mostrare i nomi a sinistra */}
            <YAxis 
              dataKey="nazione" 
              type="category" 
              axisLine={false}
              tickLine={false}
              tick={{ 
                fill: '#ffffff', 
                fontSize: "0.75rem", 
                fontWeight: "bold", 
                textTransform: "uppercase" 
              }}
              // Larghezza fissa per l'area del testo
              width={100} 
            />

            <Tooltip
              cursor={{ fill: 'transparent' }}
              contentStyle={{
                borderRadius: '10px',
                border: 'none',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                fontSize: '12px'
              }}
              formatter={(value) => [formatToEuro(value), "Fatturato"]}
            />

            <Bar
              dataKey="valore"
              radius={[0, 10, 10, 0]}
              barSize={32}
            >
              {citiesData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={index === 0 ? "rgba(241,111,36,1)" : "#5a5a5a"} />
              ))}

              {/* VALORE EURO: A destra, fuori dalla barra */}
              <LabelList
                dataKey="valore"
                position="right"
                offset={10}
                formatter={(value) => formatToEuro(value)}
                fill="rgba(241,111,36,1)"
                style={{ fontSize: "0.75rem", fontWeight: "900" }}
              />

             
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}

export default CityBarChart;